<article
  class="workout-card"
  role="button"
  tabindex="0"
  [class.workout-card--selected]="workout.isSelected"
  [class.workout-card--busy]="isLoading"
  [attr.aria-label]="cardActionLabel"
  (click)="onClick()"
  (keydown.enter)="onClick()"
  (keydown.space)="$event.preventDefault(); onClick()"
>
  <div class="workout-card__media">
    <img
      class="workout-card__image"
      *ngIf="workout?.thumbnailUrl && !thumbnailFailed; else artwork"
      [src]="workout.thumbnailUrl"
      [alt]="workout.name"
      (error)="useFallbackImage()"
    />
    <ng-template #artwork>
      <div class="workout-card__artwork">
        <mat-icon>list_alt</mat-icon>
      </div>
    </ng-template>

    <div class="workout-card__media-shade"></div>

    <div class="workout-card__top-row">
      <span class="workout-card__badge">
        {{ playlistCount }} {{ playlistCount === 1 ? "playlist" : "playlists" }}
      </span>

      <div class="workout-card__quick-actions">
        <button
          mat-icon-button
          class="card-icon-button"
          [attr.aria-label]="'Actions for ' + workout.name"
          [matMenuTriggerFor]="menu"
          (click)="$event.preventDefault(); $event.stopPropagation()"
        >
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>
    </div>

    <label
      class="workout-card__selection"
      *ngIf="isSelectionActive || isSuperadmin"
      (click)="$event.stopPropagation()"
    >
      <input
        type="checkbox"
        [checked]="workout.isSelected"
        [attr.aria-label]="'Select ' + workout.name"
        (change)="toggleSelection()"
      />
      <span class="workout-card__selection-box" aria-hidden="true">
        <mat-icon>check</mat-icon>
      </span>
    </label>

    <div class="workout-card__busy" *ngIf="isLoading">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  </div>

  <div class="workout-card__content">
    <div>
      <h3 class="workout-card__title" [title]="workout.name">
        {{ workout.name }}
      </h3>
      <p class="workout-card__description">
        {{ summary }}
      </p>
    </div>

    <div class="workout-card__details">
      <span>
        <mat-icon>queue_music</mat-icon>
        {{ playlistCount }}
        {{ playlistCount === 1 ? "playlist" : "playlists" }}
      </span>
      <span>
        <mat-icon>fitness_center</mat-icon>
        {{ exerciseCount }}
        {{ exerciseCount === 1 ? "exercise" : "exercises" }}
      </span>
    </div>
  </div>

  <mat-menu #menu="matMenu">
    <a
      mat-menu-item
      [routerLink]="_pt('sidebar_workouts_link') + '/edit/' + workout.id"
    >
      <mat-icon>edit</mat-icon>
      <span>Edit</span>
    </a>
    <button mat-menu-item *ngIf="isSuperadmin" (click)="toggleSelection()">
      <mat-icon>done</mat-icon>
      <span>{{ workout.isSelected ? "Deselect" : "Select" }}</span>
    </button>
    <button mat-menu-item (click)="openDeleteDialog()">
      <mat-icon>delete</mat-icon>
      <span>Delete</span>
    </button>
  </mat-menu>
</article>
